// extracted by mini-css-extract-plugin
export default {"container":"QFSs","pagination":"LWec","pagination-cell":"YRSg","paginationCell":"YRSg","overlay":"dQyo"};